import { render, staticRenderFns } from "./CallForwardingsPage.vue?vue&type=template&id=3747c95b&"
import script from "./CallForwardingsPage.vue?vue&type=script&lang=ts&"
export * from "./CallForwardingsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports